import { Link } from 'react-router-dom';
import { isAuthenticated } from '../../services/api';
import '../Unauthorized/unauthorized.css';

function NotFound() {
    const backPath = isAuthenticated() ? '/' : '/login';
    const backLabel = isAuthenticated() ? 'Voltar ao início' : 'Ir para login';

    return (
        <div className='unauthorized-page'>
            <div className='unauthorized-card container-white'>
                <h1>Página não encontrada</h1><br />

                <p>
                    O endereço que você tentou acessar não existe ou o conteúdo solicitado não foi encontrado.
                    Confira o link e tente novamente.
                </p>

                <Link to={backPath} className='unauthorized-link'>
                    {backLabel}
                </Link>
            </div>
        </div>
    );
}

export default NotFound;
